import { apiProxyRequest } from "Api/apiProxyRequest";
import { BillingProfileStanding } from "../types";

export const getStandingRequest = (billingProfileId: string) => {
  return apiProxyRequest<BillingProfileStanding>(
    `/billing/profiles/${billingProfileId}/standing`
  );
};
